/**
 * Shared submission-flow constants for the create / modify campaign hooks.
 */

import { FieldKey } from 'src/utils/valueMatching/form/formValidationUtils';

/**
 * Translation keys for non-field submission errors surfaced by the
 * create / modify campaign hooks. `VERSION_CONFLICT` is only emitted
 * by the modify flow (HTTP 409 from concurrent edits), but lives here
 * so all submission error keys are co-located.
 */
export const ERROR_KEYS = {
    GENERIC_SUBMISSION: 'error_generic_submission',
    CAMPAIGN_TYPE_UNAVAILABLE: 'error_campaign_type_unavailable',
    VERSION_CONFLICT: 'error_version_conflict',
} as const;

/**
 * Funding-share field keys used for cross-field validation visibility.
 * When any of these fields is touched, the aggregate "shares must sum to 100"
 * error becomes visible — even before the user submits.
 */
export const SHARE_FIELDS: FieldKey[] = ['sellerShare', 'brandShare', 'bankShare', 'amazonShare'];
